import { enumToEnumNames } from '@commonClient2/services/enums';
// eslint-disable-next-line import/prefer-default-export
export const EmployeeBiddingResultColumn = Object.freeze({
    rank: 0,
    name: 1,
    status: 2,
    scheduledOn: 3,
});
export const EmployeeBiddingResultColumnNames = enumToEnumNames(EmployeeBiddingResultColumn);
